import { useEffect, useState } from 'react';
/** the effect will not trigger on mount, only after a watcher value changes */
export var useEffectAfterMount = function (effect, watcher) {
    if (watcher === void 0) { watcher = []; }
    var _a = useState(false), hasRun = _a[0], setHasRun = _a[1];
    useEffect(function () {
        if (hasRun) {
            return effect();
        }
        setHasRun(true);
        return function () { return null; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, watcher);
};
